var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "page page__wrapper wrapper" }, [
      _c("header", { staticClass: "header header" }, [
        _c(
          "div",
          {
            staticClass: "header__logo-container header__logo-container--login"
          },
          [
            _c(
              "div",
              { staticClass: "header__logo header__logo--login" },
              [
                _c("router-link", { attrs: { to: "/" } }, [
                  _c("img", {
                    staticClass: "header__logo-img",
                    attrs: {
                      src: "/images/fuel-logo.png",
                      alt: "Fuel Member Portal"
                    }
                  })
                ])
              ],
              1
            )
          ]
        )
      ]),
      _vm._v(" "),
      _c("main", [
        _c("article", { staticClass: "page-login__container" }, [
          _c("div", { staticClass: "page-login__frame-intro" }, [
            _vm._m(0),
            _vm._v(" "),
            _c("div", { staticClass: "container" }, [
              _c("div", { staticClass: "row" }, [
                _c(
                  "div",
                  { staticClass: "col-xs-12 h-center-align" },
                  [_c("SystemMessage")],
                  1
                )
              ]),
              _vm._v(" "),
              _vm.header
                ? _c("div", { staticClass: "row" }, [_vm._m(1)])
                : _vm._e(),
              _vm._v(" "),
              _c("div", { staticClass: "row" }, [
                _c(
                  "div",
                  { staticClass: "col-sm-12 h-center-align" },
                  [_c(_vm.componentName, { tag: "component" })],
                  1
                )
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "page-login__footer" }, [
              _vm._v(
                "\n            Copyright © " +
                  _vm._s(_vm.currentYear) +
                  " Fuel Medical Group. All Rights Reserved.\n          "
              )
            ])
          ])
        ])
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "page-login__browser-alert",
        attrs: { id: "browser-alert" }
      },
      [
        _c("i", { staticClass: "browser-alert__icon fa fa-eye-slash fa-lg" }),
        _vm._v(" "),
        _c("div", { staticClass: "browser-alert__content" }, [
          _c("div", { staticClass: "browser-alert__content--header" }, [
            _vm._v("THIS WEBSITE IS NOT OPTIMIZED FOR YOUR BROWSER!")
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "browser-alert__content--text" }, [
            _vm._v("For the best experience, please use Google Chrome.")
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "browser-alert__link-container" }, [
          _c(
            "a",
            {
              staticClass: "browser-alert__link",
              attrs: { href: "https://www.google.com/chrome/" }
            },
            [
              _c("img", {
                staticClass: "browser-alert__chrome-icon",
                attrs: { src: "/images/chrome.png" }
              }),
              _vm._v("GET CHROME\n              ")
            ]
          )
        ])
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-sm-12 h-center-align" }, [
      _c("div", { staticClass: "page-login__heading" }, [
        _vm._v("Welcome to the Fuel Member Portal")
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }